export default __webpack_public_path__ + "static/media/LoadingAnimation.6a6c5242.gif";